import { IAuthenticationConfigMap } from '../types/AuthenticationConfig';
import { getAuth0ClientTypeFromUserType } from './getAuth0ClientTypeFromUserType';
import { eAccessControlUserType } from '../../enums/eAccessControlUserType';

export const getAuth0ClientConfigForUserType = (
  userType: eAccessControlUserType,
  configMap: IAuthenticationConfigMap
) => {
  const clientType = getAuth0ClientTypeFromUserType(userType);
  return configMap[clientType];
};
